import { widgetInitialisation } from "../functions/widget-init";
import { NumberUtils } from "../functions/number-utils";

widgetInitialisation(initToMilesFilter);

function initToMilesFilter() {
    Vue.filter('toMiles', function (value, options) {
        options = options || {};

        if (typeof value !== "number") {
            var parsedValue = NumberUtils.tryParse(value);
            if (parsedValue === null)
                return value;

            value = parsedValue;
        }

        if (value === 0)
            return "";

        var minimumFractionDigits = '2';
        if (typeof options.minimumFractionDigits === "number")
            minimumFractionDigits = options.minimumFractionDigits.toString();

        var formattedToPrecision = value.toFixed(minimumFractionDigits);
        var result = formattedToPrecision;
        if (formattedToPrecision.startsWith("0"))
            result = formattedToPrecision.substring(1);

        var showMilesLabel = true;
        if (options.hasOwnProperty("showMilesLabel"))
            showMilesLabel = options.showMilesLabel;

        if (showMilesLabel)
            result = `${result} Miles Away`;

        return result;
    });
}